import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-staff',
  templateUrl: './main-staff.component.html',
  styleUrls: ['./main-staff.component.css']
})
export class MainStaffComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
